const reactAux = (props: any) => props.children;

export default reactAux;
